// extracted by mini-css-extract-plugin
module.exports =  {"main":"---src-components-Shared-PageHeader__main--pWdEK","pageTitle":"---src-components-Shared-PageHeader__pageTitle--a_1zy"};